import { render } from "./ChangePickupModal.vue?vue&type=template&id=51a879af&scoped=true"
import script from "./ChangePickupModal.vue?vue&type=script&lang=js"
export * from "./ChangePickupModal.vue?vue&type=script&lang=js"

import "./ChangePickupModal.vue?vue&type=style&index=0&id=51a879af&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51a879af"]])

export default __exports__